import React, { useState } from 'react';
import { fetchAPI } from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';

export default function StudentMarks() {
    const { currentUser } = useAuth();
    const [marks, setMarks] = useState([]);
    const [loading, setLoading] = useState(true);

    React.useEffect(() => {
        const loadMarks = async () => {
            if (!currentUser) return;
            try {
                const data = await fetchAPI(`/student/get_marks.php?user_id=${currentUser.id}`);
                setMarks(data);
            } catch (err) {
                console.error("Failed to load marks", err);
            } finally {
                setLoading(false);
            }
        };
        loadMarks();
    }, [currentUser]);

    if (loading) return <div className="p-8 text-center text-gray-500 font-bold">Loading marks...</div>;

    return (
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
            <h2 className="text-2xl font-bold text-gray-900 lemon-milk mb-6">My Results</h2>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-100">
                    <thead>
                        <tr className="bg-gray-50">
                            <th className="px-6 py-4 text-left text-xs font-bold text-gray-400 uppercase tracking-widest">Exam / Class</th>
                            <th className="px-6 py-4 text-left text-xs font-bold text-gray-400 uppercase tracking-widest">Date</th>
                            <th className="px-6 py-4 text-left text-xs font-bold text-gray-400 uppercase tracking-widest">Marks</th>
                            <th className="px-6 py-4 text-left text-xs font-bold text-gray-400 uppercase tracking-widest">Grade</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-50 text-sm">
                        {marks.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="px-6 py-8 text-center text-gray-400 italic">No results found</td>
                            </tr>
                        ) : marks.map((mark) => (
                            <tr key={mark.id} className="hover:bg-gray-50/50 transition-colors">
                                <td className="px-6 py-4">
                                    <span className="font-bold text-gray-900">{mark.exam_name}</span>
                                    <span className="block text-[10px] text-gray-400 uppercase font-bold tracking-wider">{mark.class_name}</span>
                                </td>
                                <td className="px-6 py-4 text-gray-600">
                                    {new Date(mark.created_at).toLocaleDateString()}
                                </td>
                                <td className="px-6 py-4 font-bold text-gray-900">{mark.marks}</td>
                                <td className="px-6 py-4">
                                    <span className={`font-black ${mark.marks >= 75 ? 'text-green-600' :
                                        mark.marks >= 65 ? 'text-blue-600' :
                                            mark.marks >= 50 ? 'text-orange-600' :
                                                'text-red-600'
                                        }`}>
                                        {mark.marks >= 75 ? 'A' : mark.marks >= 65 ? 'B' : mark.marks >= 50 ? 'C' : 'S'}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
